export default {
  ja:[
    "提案されているアイデアから買いたいのを選んでね！",
    "値段",
    "円",
    "状態",
    "まだアイデアが届いてないみたい",
    "新品",
    "中古",
    "購入する",
  ],
  en: [
    "Please select an idea.",
    "Price",
    "JPY",
    "State",
    "No ideas yet.",
    "New",
    "Used",
    "Purchase",
  ]
}
